import PageHero from "@/components/site/PageHero";
import SEO from "@/components/site/SEO";
import { COMPANY } from "@/lib/siteData";

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-page">
      <SEO
        title="Mentions légales | RM Plomberie Chauffage VMC"
        description="Mentions légales de RM Plomberie Chauffage VMC, artisan plombier-chauffagiste à Beblenheim (68980). SIRET 891 654 949 00025."
      />
      <PageHero breadcrumb="Mentions légales" title=" légales" highlight="Mentions" />
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 prose prose-slate">
          <h2 className="font-display text-2xl font-bold text-[#001B35]">Éditeur du site</h2>
          <p className="text-gray-700">
            {COMPANY.name}<br />
            Dirigé par : {COMPANY.founder}<br />
            Adresse : {COMPANY.address}<br />
            Téléphone : <a href={`tel:${COMPANY.phoneTel}`} className="text-[#005BBB]">{COMPANY.phone}</a><br />
            E-mail : <a href={`mailto:${COMPANY.email}`} className="text-[#005BBB]">{COMPANY.email}</a><br />
            SIREN : {COMPANY.siren} — SIRET : {COMPANY.siret}<br />
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Hébergement</h2>
          <p className="text-gray-700">Site hébergé par Emergent.</p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Propriété intellectuelle</h2>
          <p className="text-gray-700">
            L'ensemble des contenus présents sur ce site (textes, images, logos) est la propriété exclusive de {COMPANY.name}. Toute reproduction, totale ou partielle, est interdite sans autorisation préalable.
          </p>

          <h2 className="font-display text-2xl font-bold text-[#001B35] mt-10">Responsabilité</h2>
          <p className="text-gray-700">
            Les informations diffusées sur ce site sont fournies à titre indicatif. {COMPANY.name} ne saurait être tenu responsable des erreurs ou omissions, ni d'éventuels dommages liés à l'utilisation du site.
          </p>
        </div>
      </section>
    </div>
  );
}
